<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm5 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="customer_report_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
        >{{ props.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.user_full_name }}</td>
        <td class="text-xs-center">{{ props.item.user_tel }}</td>
        <td class="text-xs-right">{{ props.item.user_point }}</td>
        <td class="text-xs-center">
          {{
            props.item.order_food +
              "/" +
              props.item.order_free +
              "/" +
              props.item.order_mess
          }}
        </td>
        <td class="text-xs-center">
          <v-btn
            small
            color="primary"
            class="black--text"
            :to="
              '/weserve_admin_login/control/' +
                $store.state.backOffice.province +
                '/report/detail_customer_report/' +
                props.item.user_id +
                '/' +
                props.item.user_full_name +
                '/' +
                JSON.stringify(clone_config_path.district_id) +
                '/' +
                clone_config_path.datetime_start +
                '/' +
                clone_config_path.datetime_end
            "
            >detail</v-btn
          >
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      column_items: [
        { text: "Earn point", value: "user_point", sortable: false },
        {
          text: "Food/Free/Mes",
          value: "customer_counter_order",
          sortable: false,
        },
      ],
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "num",
        },
        { text: "Customer name", value: "name", sortable: false },
        {
          text: "Tel.",
          value: "discount",
          sortable: false,
          align: "tel",
        },
        {
          text: "Earn point",
          align: "right",
          value: "earn_point",
          sortable: false,
        },
        {
          text: "Food/Free/Mes",
          align: "center",
          value: "order_type",
          sortable: false,
        },
        { text: "Detail", align: "center", sortable: false },
      ],

      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false,
    };
  },
  watch: {
    customer_report_list: {
      handler: function() {
        if (this.isSort == false) {
          this.asc_desc = "asc";
          this.sort_column = "no_default";
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      customer_report_list: (state) =>
        state.fetchCustomerReport.customer_report_list,
      clone_config_path: (state) => state.fetchCustomerReport.clone_config_path,
    }),
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.customer_report_list,
        field: this.sort_column,
        asc_desc: this.asc_desc,
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("fetchCustomerReport/getExportFormCustomer");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    },
  },
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>
